export const enum BUTTON_STATUS {
  INIT,
  IDLE,
  IN_SESSION,
}

export const enum RENDER_STATES {
  SESSION_START,
  SESSION_ERROR,
  TIME_TO_PLUGIN,
  SESSION_TIMEOUT,
}
